import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { FaqService } from '../../services/faq.service';
import { IFaqDto } from '../../interfaces/Faq/ifaq-dto';


@Component({
  selector: 'app-policy-procedure',
  templateUrl: './policy-procedure.component.html',
  styleUrls: ['./policy-procedure.component.css']
})
export class FaqPolicyProcedureComponent implements OnInit {

  faq: IFaqDto;
  loading = false;

  constructor(private sharedService: SharedService, private faqService: FaqService) { }

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadFaq();
  }

  loadFaq() {
    this.loading = true;
    this.faqService.getFaqByCode('policy-procedure').subscribe(result => {
      this.faq = result;
      this.loading = false;
      this.sharedService.showLoadingMessage = false;
    }, error => {
      console.error(error);
      this.loading = false;
      this.sharedService.showLoadingMessage = false;
    });
  }

}
